import { render, staticRenderFns } from "./equipment-table.vue?vue&type=template&id=065baafc"
import script from "./equipment-table.vue?vue&type=script&lang=ts"
export * from "./equipment-table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports